import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import {
  DropdownItem,
  FileInfo,
  MenuItemInput,
} from '@app/models/document.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  styleUrl: './dropdown-menu.component.scss',
  templateUrl: './dropdown-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {
  public items: InputSignal<ReadonlyArray<MenuItemInput>> = input<
    ReadonlyArray<MenuItemInput>
  >([]);
  public pick: OutputEmitterRef<string> = output<string>();
  public viewItems = signal<DropdownItem[]>([]);

  constructor() {
    effect(() => {
      const incoming = this.items() ?? [];
      this.viewItems.set(incoming.map(this.toDropdownItem));
    });
  }

  private toDropdownItem(it: MenuItemInput): DropdownItem {
    if ((it as DropdownItem).key !== undefined) return it as DropdownItem;

    // FileInfo -> DropdownItem
    const file = it as FileInfo;
    const name = (file.name ?? 'file').toString();
    const ext = (file.extension ?? '').toString().replace(/^\./, '');
    const label = ext ? `${name}.${ext}` : name;

    return { key: file.id, label, iconClass: 'fa fa-download' };
  }

  trackKey = (_: number, it: DropdownItem) => it.key;

  onItemClick(item: DropdownItem, event: MouseEvent): void {
    if (item.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.pick.emit(item.key);
  }
}
